import React from "react";
import "./style.scss";

export const LinkMessenger = ({ link, img, className, ariaLabel }) => {
  return (
    <a
      className={`${className}`}
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      aria-label={ariaLabel}
    >
      <img src={img} alt={ariaLabel} />
    </a>
  );
};
